// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.favorite-btn {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 20px;
  padding: var(--space-1);
  border-radius: var(--radius-full);
  transition: transform var(--transition-fast);
  line-height: 1;
}

.favorite-btn:active {
  transform: scale(1.2);
}

.favorite-btn--active {
  animation: favorite-pulse 0.3s ease;
}

@keyframes favorite-pulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.3); }
  100% { transform: scale(1); }
}
`, "",{"version":3,"sources":["webpack://./src/features/games/FavoriteButton.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,uBAAuB;EACvB,iCAAiC;EACjC,4CAA4C;EAC5C,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,KAAK,mBAAmB,EAAE;EAC1B,MAAM,qBAAqB,EAAE;EAC7B,OAAO,mBAAmB,EAAE;AAC9B","sourcesContent":[".favorite-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 20px;\n  padding: var(--space-1);\n  border-radius: var(--radius-full);\n  transition: transform var(--transition-fast);\n  line-height: 1;\n}\n\n.favorite-btn:active {\n  transform: scale(1.2);\n}\n\n.favorite-btn--active {\n  animation: favorite-pulse 0.3s ease;\n}\n\n@keyframes favorite-pulse {\n  0% { transform: scale(1); }\n  50% { transform: scale(1.3); }\n  100% { transform: scale(1); }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
